import { AnyAction } from "redux";
import { FindById} from "../../../universities";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";

export const FETCH_GET_UNIVERSITY_REQUEST = 'FETCH_GET_UNIVERSITY_REQUEST';
export const FETCH_GET_UNIVERSITY_SUCCESS = 'FETCH_GET_UNIVERSITY_SUCCESS';
export const FETCH_GET_UNIVERSITY_FAILURE = 'FETCH_GET_UNIVERSITY_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchGetUniversityRequest = () => {
    return {
        type: FETCH_GET_UNIVERSITY_REQUEST,
    };
};

const fetchGetUniversitySuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_GET_UNIVERSITY_SUCCESS,
        payload: data
    };
};

const fetchGetUniversityFailure = (error: any) => {
    return {
        type: FETCH_GET_UNIVERSITY_FAILURE,
        payload: error,
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchGetUniversityRequest());
        try {
            const response = await FindById(id , "fields=*.*.*.*");
            dispatch(fetchGetUniversitySuccess(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchGetUniversityFailure(error.message));
        }
    };
};
